import { principles } from "@/mocks/home";

export default function Method() {
  return (
    <section id="method" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-4 w-1 rounded bg-primary-500" />
              信任 · 我们凭什么追得稳
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              一套不打折扣的追更标准
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              持续更新不是越快越好，而是越稳越好。我们给每一条实时跟进都定下纪律，让「51吃料最新进展」
              经得起反复核对，也让后续发展对得起你的每一次回访。
            </p>
            <a href="#faq" className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-500">
              关于追更的更多问题
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.no} className="rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300">
                <span className="font-heading text-lg font-black text-accent-600">{p.no}</span>
                <h3 className="mt-3 font-heading text-lg font-black text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-[13px] leading-6 text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}